module.exports = {"title":"APL 운영 모니터링","clubOperationStatus":"골프클럽 운영 상태","lastUpdated":"최근 업데이트","refresh":"새로고침","totalGolfClub":"전체 골프클럽","operating":"운영중","operatingScheduled":"운영 예정","progressStatus":"진행상태","totalApl":"전체 APL","serviceOperating":"서비스 운영","serviceIdle":"서비스 대기","aplCommError":"APL 통신 오류","lowBattery":"배터리 부족","batteryOut":"방전","total":"전체","operation":"운영","standby":"대기","normalApl":"정상 APL","commError":"통신 오류","pinError":"핀 오류","batteryNormal":"배터리 정상","needCharge":"충전 필요","noData":"데이터가 없습니다.","sum":"합계"}


//////////////////
// WEBPACK FOOTER
// ./src/locales/ko/ho001.json
// module id = gBjR
// module chunks = 2